export default __webpack_public_path__ + "static/media/billers.f4d6e802.svg";